module.exports = __webpack_public_path__ + "static/media/icon-double-chevon-right-white.f00a6cad.svg";